export const BUSINESS_ADDRESS_REQUIRED_EXPERIMENT = 'ola_is_business_address_required';
export const ADD_SERVICES_MUTATOR = 'add_services_via_mutator';
export const OLA_BENEFITS = 'ola_benefits_zerostate_BEAR-3839';
export const OLA_BOOKING_SERVICE_LOCATION = 'ola_booking_service_location';
export const OLA_BOOK_BUTTON_PROMINENT = 'ola_book_button_prominent';
export const OLA_BOOK_BUTTON_PROMINENT_AA = 'aa-ola-book-now';
export const OLA_ADDON = 'ola-addon';
export const OLA_MUTATOR_BUSINESS_ADDRESS_FORM = 'ola-mutator-business-address-form';
export const OLA_AUTO_ADD_SERVICES = 'ola-auto-add-services';
export const OLA_ADDON_PHASE_II = 'ola-addons-phase-2';
export const OLA_ADDON_PHASE_II_AA_TEST = 'ola-addons-phase-2-aa-test-2';
export const OLA_WTP_2 = 'ola-standalone-freemium-to-wam-test';
export const OLA_AUTOSAVE_STARTER_SERVICES_AA =
  'ola-aa-wsb-autosave-services-on-autoadded-olawidget';
export const OLA_AUTOSAVE_STARTER_SERVICES_AB =
  'ola-ab-wsb-autosave-services-on-autoadded-olawidget';
// VNEXT-81525: AB test id for the LLM model upgrade behind service/description/image recommendations.
export const OLA_GEN_AI_V2 = 'ola-llm-upgrade-service-recommendation';
